// extracted by mini-css-extract-plugin
var _1 = "Sidebar-module__animateUploadProgressBarWidth--f0iy1";
var _2 = "Sidebar-module__animatedBackground--VgjY5";
var _3 = "Sidebar-module__contentMapIcon--yQaKT";
var _4 = "Sidebar-module__draftsIcon--coBTU";
var _5 = "Sidebar-module__isSidebarSectionsModalOpen--o_M2L";
var _6 = "Sidebar-module__mainNavs--I0xsT";
var _7 = "Sidebar-module__navs--JessK";
var _8 = "Sidebar-module__scrolled--ZZMu7";
var _9 = "Sidebar-module__sidebar--UHP6v";
var _a = "Sidebar-module__teamNavRow--SFjFq";
var _b = "Sidebar-module__teamNavRowInner--m97Kt";
var _c = "Sidebar-module__userAvatar--kPvYb";
var _d = "20px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "contentMapIcon", _4 as "draftsIcon", _5 as "isSidebarSectionsModalOpen", _6 as "mainNavs", _7 as "navs", _8 as "scrolled", _9 as "sidebar", _a as "teamNavRow", _b as "teamNavRowInner", _c as "userAvatar", _d as "userAvatarSize" }
